import { useRef } from 'react';

// Hook to handle scrolling to a component
export const useScrollTo = (block: ScrollLogicalPosition = 'start') => {
  const elementRef = useRef<HTMLElement | null>(null);

  const scrollToElement = () => {
    if (elementRef.current) {
      elementRef.current.scrollIntoView({ behavior: 'smooth', block });
    }
  };

  return [elementRef, scrollToElement] as const;
};
